import React from "react";
import styled from "styled-components";
import Text from "@kiwicom/orbit-components/lib/Text";

import Link from "next/link";
import { useRouter } from "next/router";

const StyledMenuItem = styled.a`
  border-left: ${({ active, theme }) =>
    active
      ? `4px solid ${theme.orbit.paletteProductNormal}`
      : `4px solid transparent`};
  box-sizing: border-box;
  background: ${({ active }) => active && `#F5F7F9`};
  color: ${({ theme }) => theme.orbit.colorTextPrimary};
  display: block;
  text-align: left;
  text-decoration: none;
  padding: 12px 0;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: #f5f7f9;
  }
`;

const StyledMenuItemIcon = styled.div`
  display: inline-block;
  margin-left: 20px;
  vertical-align: middle;
`;

const StyledMenuItemText = styled.span`
  display: inline-block;
  margin-left: 10px;
`;

const NextLink = ({ isNextLink, wrapper, children }) =>
  isNextLink ? wrapper(children) : children;

const MenuItem = ({ href, icon, children, linkTo }) => {
  const router = useRouter();

  return (
    <NextLink
      isNextLink={linkTo}
      wrapper={children => <Link href={linkTo}>{children}</Link>}
    >
      <StyledMenuItem href={href} active={router.pathname === linkTo}>
        <StyledMenuItemIcon>
          {React.cloneElement(icon, { size: "small" })}
        </StyledMenuItemIcon>
        <StyledMenuItemText>
          <Text>{children}</Text>
        </StyledMenuItemText>
      </StyledMenuItem>
    </NextLink>
  );
};

export default MenuItem;
